import { render, staticRenderFns } from "./_base-modal-confirm.vue?vue&type=template&id=e8f9dcea"
import script from "./_base-modal-confirm.vue?vue&type=script&lang=js"
export * from "./_base-modal-confirm.vue?vue&type=script&lang=js"
import style0 from "./_base-modal-confirm.vue?vue&type=style&index=0&id=e8f9dcea&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports